import { render } from "./momo-ghs-levy-info.vue?vue&type=template&id=52137320&scoped=true"
import script from "./momo-ghs-levy-info.vue?vue&type=script&lang=js"
export * from "./momo-ghs-levy-info.vue?vue&type=script&lang=js"

import "./momo-ghs-levy-info.vue?vue&type=style&index=0&id=52137320&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52137320"]])

export default __exports__